import { getWordCount } from '@/helpers/wordCount';
import { contextAddContent } from '@/lib/analytics/scribe/context';
import { logger } from '@/utils/logger/logger';
import { sanitizeError } from '@/utils/logger/sanitizeError';
import { toast } from '@heidi/design-system/toast';
import { useMarkImproveNotesTaskComplete } from '@heidi/growth';
import { useMutateUpdateContextContent as useMutateUpdateContextContentCore } from '@heidi/session/data';
import { getCurrentUser } from '../query/useQueryUser';

export function useMutateUpdateContextContent() {
  const userId = getCurrentUser()?.kinde_user_id || '';
  const markImproveNotesTaskComplete = useMarkImproveNotesTaskComplete();

  return useMutateUpdateContextContentCore({
    onSuccess: (_, input) => {
      const wordCount = getWordCount(input.context?.at(0) ?? '');
      contextAddContent({
        sessionId: input.sessionId,
        wordCount,
        userId,
      });
      // The debounced save also fires for cleared content, so only
      // non-empty context counts as evidence of use.
      if (wordCount > 0) {
        markImproveNotesTaskComplete('add-context');
      }
    },
    onError: (error, variables) => {
      const { sessionId } = variables;
      logger.error('Failed to update session context', {
        sessionId,
        error: sanitizeError(error),
      });
      toast({
        tone: 'destructive',
        title: 'Backend Error',
      });
    },
  });
}
